'use client';

import { useEffect, useState } from 'react';
import { useSession } from 'next-auth/react';
import { useRouter } from '@/i18n/navigation';
import useSearchParams from '@/hooks/useSearchParams';
import AuthModal from '@/components/ui/modals/auth-modal';

const LinksList = ({ data = [], locale }) => {
  const [auth, setAuth] = useState(false);
  const { data: session } = useSession();
  const { push } = useRouter();
  const { setFilterQueryHandler, getFilterObj } = useSearchParams();

  const handleLinkClick = (link) => {
    const isUserLink = link.url?.startsWith('user/');
    const isAuthenticated = !!session?.user;

    if (isUserLink && !isAuthenticated) {
      setFilterQueryHandler({ url: link.url });
      setAuth('login-email');
    } else {
      push(`/${link?.url}`);
    }
  };

  useEffect(() => {
    if (session?.user && getFilterObj?.url) {
      push(getFilterObj?.url);
    }
  }, [getFilterObj?.url, push, session?.user]);

  return (
    <>
      <div className='flex items-center gap-4'>
        {data
          ?.filter((item) => item?.active)
          ?.map((link, idx) => (
            <button
              key={`top-header-link-${idx}`}
              onClick={() => handleLinkClick(link)}
              className='cursor-pointer text-xs'
            >
              {link[`title-${locale}`]}
            </button>
          ))}
      </div>
      <AuthModal auth={auth} setAuth={setAuth} />
    </>
  );
};

export default LinksList;
